import styled from 'styled-components';
import { H1, Overline } from 'components/Typography';

const HeroContainer = styled.div`
  padding: 0 0 40px;

  @media (max-width: 768px) {
    flex-direction: column;
    margin: 0;
    padding: 0;
  }
`;

const Container = styled.div`
  display: flex;
  position: relative;

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 0 0 30px 0;
    margin: 0;
  }

  h1 {
    @media (max-width: 992px) {
      font-size: 36px;
      line-height: 44px;
    }
  }
`;

const Copy = styled.div`
  height: 100%;
  width: 65%;
  position: relative;
  padding-right: 40px;

  @media (max-width: 768px) {
    width: 100%;
    padding: 0;
  }
`;

const Form = styled.div`
  position: absolute;
  right: 0;
  width: 35%;
  margin-top: -30px;

  .signup-form--container {
    padding: 24px 20px;

    .signup-form--title {
      font-size: 23px;
      line-height: 150%;
      margin-bottom: 10px;
    }

    .radio-field--title {
      color: white;
    }

    .radio-div {
      label {
        background: white;
        color: var(--disabled-text-color);
      }

      &.selected label,
      &.selected:last-child label
      input:checked + label {
        background: white;
        border: 3px solid white;
      }
    }
  }

  @media (max-width: 768px) {
    margin: 30px 0;
    width: 100%;
    position: relative;
    right: 0;
  }
`;

const Kicker = styled(Overline)`
  color: var(--blue-secondary);
  font-weight: 900;
  font-size: 16px;
`;

const Title = styled(H1)`
  color: var(--black);
  font-weight: 900;
  margin: 20px 0 15px 0 !important;
`;

export { HeroContainer, Container, Copy, Form, Kicker, Title };
